import React from 'react'
import '../../assets/home/pub.css'
import { Link } from 'react-router-dom';

function Pub() {
  return (
    <div className='container-fluid pub'>
        <div>
            <h1>-10% DÈS 3 ARTICLES ACHETÉS*</h1>
            <p>*Remise automatique valable sur les fleurs et résines</p>
        </div>
        <div>
        <button>VOIR LES PRODUITS ÉLIGIBLES</button>
        <p className='mt-3'><Link to={''}>Découvrir notre programme de fidélité <img src="./images/fleche_blanche.svg" alt="" /></Link></p>
        </div>
    </div>
  )
}

export default Pub